import { actionTypes } from "../constants/action-types"


const initialState = {
    insights : []
}

export const insightsReducer = (state = initialState, {type, payload={}} ) => {
    switch(type)
    {
        case actionTypes.GET_INSIGHTS :
            return {
                  ...state, insights: payload

            }
        default :
        return state

    }
    
} 